import { render } from "./StartWwe.vue?vue&type=template&id=70d0160e"
import script from "./StartWwe.vue?vue&type=script&lang=js"
export * from "./StartWwe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__